import React from "react";
import { ProductTypes } from "../../../../../part-panel/lib/product-types";
import { PaletteFromHex, rgbToHex } from "../../../../helpers/palette";
import { toElementProps } from "../../Element";

export function ProductTypeImageStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .product-type-image": {
            "& img, svg": {
                width: "100%",
            },

            [MobileBreakpoint]: {
                display: "flex",
                justifyContent: "center",
            },
        },
    };
}

export default function ProductTypeImage(props) {
    const refProductType = React.useRef(null);

    const { ProductType, ProductPicture, color } = props.variables;

    // !TODO Remove if unused (FullWidthBg, EventHeader already inside variables)
    const {
        variables: { FullWidthBg },
    } = ProductTypes.filter(type => type.value === ProductType)[0];

    React.useEffect(() => {
        LoadSVG();
    }, [ProductPicture, refProductType, color]);

    function LoadSVG() {
        if (FullWidthBg) {
            return null;
        }

        let svgColor;
        {
            const currentColor = getComputedStyle(refProductType.current).color;

            const [_, r, g, b] = currentColor.match(/(\d{1,3}), ?(\d{1,3}), ?(\d{1,3})/) || [];

            if (_) {
                svgColor = [r, g, b].join("") === "000" ? "" : "-white";
            }
        }

        fetch(`/img/product-types/${ProductType}${svgColor}.svg`)
            .then(r => r.text())
            .then(textXml => {
                if (!textXml) {
                    return;
                }

                if (!refProductType?.current) {
                    return;
                }

                for (const child of refProductType.current.children) {
                    if (child.parentElement) {
                        child.parentElement.removeChild(child);
                    }
                }

                let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svg.innerHTML = textXml;
                svg = svg.firstChild;
                refProductType.current.appendChild(svg);

                const images = svg.querySelectorAll(".svg-product-type-image");

                if (!ProductPicture) {
                    return;
                } else {
                    const retina = window.devicePixelRatio > 1;
                    images.forEach((image, index) => {
                        const pp = ProductPicture[index];
                        const href = (retina && pp?.retina) || pp?.normal || pp?.src || pp?.file?.dataUrlBase64;

                        image.setAttribute("href", href);

                        if (!ProductPicture[index]) {
                            image.removeAttribute("href");
                        }
                    });
                }
            });
    }

    const elProps = toElementProps(props, { className: ["product-type-image", ProductType] });
    return <div ref={refProductType} {...elProps}></div>;
}
